import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class CommentsWidget extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    src: PropTypes.string
  }

  constructor(props) {
    super(props);

    this.state = {
      iframe: null,
      height: 600,
      isLoading: true
    }

    this.iframeId = props.id
    this.receiveMessage = this._receiveMessage.bind(this)
    this.onIframeLoad = this._onIframeLoad.bind(this)
  }

  getIframeData(iframe) {
    if (!iframe) return

    iframe.contentWindow.postMessage("getDocumentHeight", this.props.src)
  }

  _receiveMessage(event) {
    if (event.origin !== "https://d2iun5pubia9jk.cloudfront.net") return

    const { isReady, height } = event.data

    if (!isReady) {
      setTimeout(() => this.getIframeData(this.state.iframe), 1000)

      return
    }

    this.setState({ height: height || this.state.height, isLoading: false })
  }

  _onIframeLoad() {
    const iframe = document.getElementById(this.iframeId)

    this.setState({ iframe })
    this.getIframeData(iframe)
  }

  componentDidMount() {
    window.addEventListener("message", this.receiveMessage, false)
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.receiveMessage, false)
  }

  render() {
    const { isLoading } = this.state.isLoading

    return (
      <div className="c-comments-wrapper">
        <iframe
          id={this.iframeId}
          className="c-comment-iframe"
          src={this.props.src}
          width="100%"
          height={`${this.state.height}px`}
          style={{ display: isLoading ? "none" : "block" }}
          frameBorder="0"
          onLoad={this.onIframeLoad}
        />
        {isLoading && <div className="c-comments-loader" />}
      </div>
    )
  }
}

export default CommentsWidget



// WEBPACK FOOTER //
// ./webapp/components/elements/CommentsWidget.js